import React from 'react';
import { DayPickerRangeController } from 'react-dates';
import css from './CustomRangeInput.module.css';
import moment from 'moment';

const CustomRangeInput = props => {
  const {
    focusedInput,
    setFocusedInput,
    setSelectedDates,
    selectedDates,
    allTimeSlots,
    isBookingTimeForm,
    onBookingStartDateChange,
    values,
    form,
    isBookingDaysForm
  } = props;

  // Function to check if a date is within any of the available time slots
  const isDateInTimeSlots = (day, allTimeSlots) => {
    return allTimeSlots?.some(slot => {
      const start = moment(slot?.attributes?.start);
      const end = moment(slot?.attributes?.end);
      return day.isSameOrAfter(start, 'day') && day.isBefore(end, 'day'); // Ensure 'end' is not included
    });
  };

  const isDateAndTimeInTimeSlots = (day, allTimeSlots) => {
    return allTimeSlots?.some(slot => {
      const start = moment(slot?.attributes?.start);
      const end = moment(slot?.attributes?.end);
  
      const isSameDayOfWeek = day.day() === start.day();
  
      // Check if the day is within the same month as the time slot
      const isSameMonth = day.month() === start.month() && day.year() === start.year();
  
      // Additionally, check if the day falls within the time slot's date range
      const isWithinSlotRange = day.isBetween(start, end, 'day', '[]');
  
      return isSameDayOfWeek && isSameMonth && isWithinSlotRange;
    });
  };

  // Function to block dates that are not in the time slots
  const isOutsideRange = day => {
    if (isBookingTimeForm) {
      return !isDateAndTimeInTimeSlots(day, allTimeSlots);
    } else {
      return !isDateInTimeSlots(day, allTimeSlots);
    }
  };

  // Function to handle date selection and add/remove dates from selectedDates array
  const handleDateChange = (day) => {
    let newSelectedDates = [...selectedDates];
    const dateIndex = newSelectedDates.findIndex(date => date.isSame(day, 'day'));
  
    if (dateIndex > -1) {
      newSelectedDates.splice(dateIndex, 1);
      if(isBookingTimeForm){
        const updatedIndex = newSelectedDates.findIndex(date => date.isSame(day, 'day'));
      onBookingStartDateChange(day, updatedIndex ,values);
      }
    } else {
      newSelectedDates.push(day);
    }
     
    if(isBookingTimeForm){
      const updatedIndex = newSelectedDates.findIndex(date => date.isSame(day, 'day'));
    onBookingStartDateChange(day, updatedIndex ,values);
    }
    if(isBookingDaysForm){
      form.change('selectedDates', newSelectedDates);
    }
    setSelectedDates(newSelectedDates);
  };



  const renderDayContents = day => {
    const isSelected = selectedDates.some(date => date.isSame(day, 'day'));

    return (
      <div
        className={isSelected ? css.selectedDay : ''}
        onClick={e => {
          // Prevent selection if the date is outside of the valid range
          if (!isOutsideRange(day)) {
            handleDateChange(day);
          }
        }}
      >
        {day.format('D')}
      </div>
    );
  };

  const orientation =
    typeof window !== 'undefined' && window.matchMedia('(max-width: 1023px)')?.matches
      ? 'vertical'
      : 'horizontal';

  return (
    <div className={css.customDatepicker}>
      <DayPickerRangeController
        startDate={moment()}
        endDate={null}
        onDatesChange={({ startDate, endDate }) => {
          setFocusedInput(focusedInput === 'startDate' ? 'endDate' : 'startDate');
        }}
        focusedInput={focusedInput}
        onFocusChange={focusedInput => setFocusedInput(focusedInput)}
        numberOfMonths={1}
        isOutsideRange={isOutsideRange}
        hideKeyboardShortcutsPanel
        renderDayContents={renderDayContents}
        keepOpenOnDateSelect
        orientation={orientation}
      />
    </div>
  );
};

export default CustomRangeInput;
